import { updateObject } from './../../utils/utility';
import { format } from 'date-fns';
import { getUpdatedRevitalizeVendors, transformCountryVendorData, transformCountryVendorDataRevitalize, transformUpdatedCountryVendorData } from '../../libs/data-transform';

const initialState = {
    quoteGeneralData: {
        quoteNumber: "",
        customerName: "",
        orgId: "",
        contactEmailAddress: "",
        dateOfRequest: format(new Date(), 'MM-dd-yyyy'),
        quoteCreationDate: null,
        numberOfAssets: "",
        requestorType: "direct",
        requestType: "RFI",
        leadOrigin: "Customer",
        leadSource: "HP Sales",
        countriesRequested: "",
        validCountries: [],
        leadCountry: "",
        geographicalScope: "",
        region: "",
        ctResponsible: "",
        salesContactEmailAddress: "",
        currency: "",
        quoteValidUntil: format(new Date(Date.now() + 2.592e+9), 'MM-dd-yyyy'), // by default set 1 month from now
        quoteStatus: "DRAFT",
        quoteSubmissionDate: "",
        acceptanceRejectionDate: "",
        winningDeliveryPartner: "",
        npsSurveySent: "",
        selectedVendorMaxNetValue: "maxNetValue"
    },
    tableData: {
        quoteGeneral: null,
        paymentOnePointOneMargins: null,
        paymentOnePointOMargins: null,
    },
    paymentOnePointOneDefaultMargins: [],
    paymentOnePointODefaultMargins: [],
    paymentOnePointOneMarginData: [],
    paymentOnePointOMarginData: [],
    directQuoteData: null,
    countryList: [],
    quoteId: "",
    fileName: "",
    fileHPName: "",
    backButtonFlag: false,
    fileUploadStatus: false,
    fileUploadStatusDesc: "",
    fileHPUploadStatus: false,
    vendorSelection: "country_coverage",
    rateCardSelection: "hardware_service",
    subRateCardSelection: "vendor_specific",
    rateConversionSelection: "NONE",
    vendorSelectionData: [],
    vendorSelectionDataCopy: [],
    vendorsList: [],
    initialQuoteType: "DRS",
    internalHPComments: "",
    vendorMatrixSelections: [],
    vendorNetValues: [],
    convertedVendorNetValues: [],
    userSelectedVendor: "",
    priceLists: [],
    servicePriceLists: [],
    selectedPriceList: "",
    selectedServicePriceList: "",
    directQuoteSaveSuccess: false,
    directQuoteSaveActionType: "",
    vendorError: "",
    countryError: "",
    userSelectedTotalVendorNetValue: {},
    maxNetValue: [],
    revitalizeVendorList: [],
    requestTypeOptions: [],
    leadOriginOptions: [],
    leadSourceOptions: [],
    rejectionReasonOptions: [],
    enable_pyxtech: false
}

const setQuoteId = (state = initialState, action) => {
    return updateObject(state, {
        quoteId: action.data
    });
}
const setFileName = (state = initialState, action) => {
    return updateObject(state, {
        fileName: action.data
    });
}
const setHPFileName = (state = initialState, action) => {
    return updateObject(state, {
        fileHPName: action.data
    });
}
const backButtonStatus = (state = initialState, action) => {
    return updateObject(state, {
        backButtonFlag: action.data
    });
}
const setFileUploadStatus = (state = initialState, action) => {
    return updateObject(state, {
        fileUploadStatus: action.data
    });
}
const setFileUploadStatusDesc = (state = initialState, action) => {
    return updateObject(state, {
        fileUploadStatusDesc: action.data
    });
}
const setHPFileUploadStatus = (state = initialState, action) => {
    return updateObject(state, {
        fileHPUploadStatus: action.data
    });
}
const setVendorSelection = (state = initialState, action) => {
    return updateObject(state, {
        vendorSelection: action.data
    });
}
const setRateCardSelection = (state = initialState, action) => {
    return updateObject(state, {
        rateCardSelection: action.data
    });
}
const setRateConversionSelection = (state = initialState, action) => {
    return updateObject(state, {
        rateConversionSelection: action.data
    });
}

const updateQuoteGeneralDataField = (state = initialState, action) => {
    const { name, value } = action.data;

    if (state.quoteGeneralData.hasOwnProperty(name)) {
        return updateObject(state, {
            quoteGeneralData: updateObject(state.quoteGeneralData, {
                [name]: value
            })
        });
    }

    return state;
}

const updatePaymentOnePointOneDefaultMargins = (state = initialState, action) => {
    return updateObject(state, {
        paymentOnePointOneDefaultMargins: action.data
    });
}

const updatePaymentOnePointODefaultMargins = (state = initialState, action) => {
    return updateObject(state, {
        paymentOnePointODefaultMargins: action.data
    });
}

const resetPaymentOnePointOneDefaultMargins = (state = initialState, action) => {
    return updateObject(state, {
        paymentOnePointOneDefaultMargins: []
    });
}

const resetPaymentOnePointODefaultMargins = (state = initialState, action) => {
    return updateObject(state, {
        paymentOnePointODefaultMargins: []
    });
}

const updatePaymentOnePointOneMarginData = (state = initialState, action) => {
    return updateObject(state, {
        paymentOnePointOneMarginData: action.data
    });
}

const updatePaymentOnePointOMarginData = (state = initialState, action) => {
    return updateObject(state, {
        paymentOnePointOMarginData: action.data
    });
}

const updateCountryList = (state = initialState, action) => {
    return updateObject(state, {
        countryList: action.data
    });
}

const setDirectQuoteData = (state = initialState, action) => {
    return updateObject(state, {
        directQuoteData: action.data
    });
}

const setQuoteRequestTypeOptions = (state = initialState, action) => {
    return updateObject(state, {
        requestTypeOptions: action.data
    });
}

const setLeadOriginOptions = (state = initialState, action) => {
    return updateObject(state, {
        leadOriginOptions: action.data
    });
}

const setLeadSourceOptions = (state = initialState, action) => {
    return updateObject(state, {
        leadSourceOptions: action.data
    });
}

const setRejectionReasonOptions = (state = initialState, action) => {
    return updateObject(state, {
        rejectionReasonOptions: action.data
    });
}

const setEnableUnifiedCapabilities = (state = initialState, action) => {
    return updateObject(state, {
        enable_pyxtech:( action.data?.pyxtech_enable === "true") ? true : false
    });
}

const setVendorSelectionData = (state = initialState, action) => {
    const { vendorData, needsTransformation, constructVendorDataCopy = false } = action.data;
    let transformedData = needsTransformation ? transformCountryVendorDataRevitalize(vendorData, state.initialQuoteType) : vendorData;
    const vendorSelectionDataCopy = constructVendorDataCopy ? transformedData : state.vendorSelectionDataCopy;

    if (!needsTransformation) {
        const formatedData = transformUpdatedCountryVendorData(transformedData)
        transformedData = [...formatedData]
    }

    return updateObject(state, {
        vendorSelectionData: transformedData,
        vendorSelectionDataCopy
    });
}

const setInitialQuoteType = (state = initialState, action) => {
    return updateObject(state, {
        initialQuoteType: action.data.initialQuoteType
    });
}

const setInternalHPComment = (state = initialState, action) => {
    return updateObject(state, {
        internalHPComments: action.data.internalHPComments
    });
}

const setVendorList = (state = initialState, action) => {
    // console.log({vendorData: transformCountryVendorData(action.data.vendorData)})
    return updateObject(state, {
        vendorsList: action.data
    });
}

const setRevitalizeVendors = (state = initialState, action) => {
    return updateObject(state, {
        revitalizeVendorList: action.data
    });
}

const setVendorMatrixSelections = (state = initialState, action) => {
    return updateObject(state, {
        vendorMatrixSelections: action.data
    });
}

const setVendorNetValues = (state = initialState, action) => {
    return updateObject(state, {
        vendorNetValues: action.data
    });
}

const setUserSelectedVendor = (state = initialState, action) => {
    return updateObject(state, {
        userSelectedVendor: action.data
    });
}
const setDirectQuoteField = (state = initialState, action) => {
    return updateObject(state, {
        [action.data.id]: action.data.value
    });
}
const setDirectQuoteSaveSuccess = (state = initialState, action) => {
    return updateObject(state, {
        directQuoteSaveSuccess: true,
        directQuoteSaveActionType: action.data
    });
}
const updateTableData = (state = initialState, action) => {
    const { name, value } = action.data;

    if (state.tableData.hasOwnProperty(name)) {
        return updateObject(state, {
            tableData: updateObject(state.tableData, {
                [name]: value
            })
        });
    }

    return state;
}
const resetQuoteData = (state = initialState) => {
    //return updateObject(state, initialState);
    return updateObject(initialState, {
        quoteGeneralData: updateObject(initialState.quoteGeneralData, {
            ctResponsible: state.quoteGeneralData.ctResponsible
        })
    });
}

const setVendorError = (state = initialState, action) => {
    return updateObject(state, {
        vendorError: action.data
    });
}

const setConvertedVendorNetValues = (state = initialState, action) => {
    return updateObject(state, {
        convertedVendorNetValues: action.data
    });
}

const setCountryError = (state = initialState, action) => {
    return updateObject(state, {
        countryError: action.data
    });
}

const setUserSelectedTotalVendorNetValue = (state = initialState, action) => {
    return updateObject(state, {
        userSelectedTotalVendorNetValue: action.data
    });
}

const setMaxNetValue = (state = initialState, action) => {
    return updateObject(state, {
        maxNetValue: action.data
    });
}

const reducer = (state = initialState, action) => {
    if (action.type === "SET_QUOTE_ID") {
        return setQuoteId(state, action)
    }
    if (action.type === "SET_FILE_NAME") {
        return setFileName(state, action)
    }
    if (action.type === "SET_HP_FILE_NAME") {
        return setHPFileName(state, action)
    }
    if (action.type === "BACK_BUTTON_CLICKED") {
        return backButtonStatus(state, action)
    }
    if (action.type === "SET_DIRECT_QUOTE_FIELD") {
        return setDirectQuoteField(state, action)
    }
    if (action.type === "SET_FILE_UPLOAD_STATUS") {
        return setFileUploadStatus(state, action)
    }
    if (action.type === "SET_FILE_UPLOAD_STATUS_DESC") {
        return setFileUploadStatusDesc(state, action)
    }
    if (action.type === "SET_HP_FILE_UPLOAD_STATUS") {
        return setHPFileUploadStatus(state, action)
    }
    if (action.type === "SET_VENDOR_SELECTION") {
        return setVendorSelection(state, action)
    }
    if (action.type === "SET_RATE_CARD_SELECTION") {
        return setRateCardSelection(state, action)
    }
    if (action.type === "SET_RATE_CONVERSION_SELECTION") {
        return setRateConversionSelection(state, action)
    }
    if (action.type === "UPDATE_QUOTE_GENERAL_DATA_FIELD") {
        return updateQuoteGeneralDataField(state, action);
    }
    if (action.type === "UPDATE_PAYMENT_ONE_POINT_ONE_DEFAULT_MARGINS") {
        return updatePaymentOnePointOneDefaultMargins(state, action);
    }
    if (action.type === "UPDATE_PAYMENT_ONE_POINT_O_DEFAULT_MARGINS") {
        return updatePaymentOnePointODefaultMargins(state, action);
    }
    if (action.type === "UPDATE_PAYMENT_ONE_POINT_ONE_MARGIN_DATA") {
        return updatePaymentOnePointOneMarginData(state, action);
    }
    if (action.type === "UPDATE_PAYMENT_ONE_POINT_O_MARGIN_DATA") {
        return updatePaymentOnePointOMarginData(state, action);
    }
    if (action.type === "RESET_PAYMENT_ONE_POINT_ONE_DEFAULT_MARGINS") {
        return resetPaymentOnePointOneDefaultMargins(state, action);
    }
    if (action.type === "RESET_PAYMENT_ONE_POINT_O_DEFAULT_MARGINS") {
        return resetPaymentOnePointODefaultMargins(state, action);
    }
    if (action.type === "UPDATE_COUNTRY_LIST") {
        return updateCountryList(state, action);
    }
    if (action.type === "SET_NEW_DIRECT_QUOTE_CREATED") {
        return setDirectQuoteData(state, action);
    }
    if (action.type === 'SET_VENDOR_DATA') {
        return setVendorSelectionData(state, action);
    }
    if (action.type === 'SET_INITIAL_QUOTE_TYPE') {
        return setInitialQuoteType(state, action);
    }
    if (action.type === 'SET_INTERNAL_HP_COMMENT') {
        return setInternalHPComment(state, action);
    }
    if (action.type === 'SET_VENDOR_LIST') {
        return setVendorList(state, action);
    }
    if (action.type === 'SET_REVITALIZE_VENDOR') {
        return setRevitalizeVendors(state, action);
    }
    if (action.type === 'SET_VENDOR_MATRIX_SELECTIONS') {
        return setVendorMatrixSelections(state, action);
    }
    if (action.type === 'SET_VENDOR_NET_VALUES') {
        return setVendorNetValues(state, action);
    }
    if (action.type === 'SET_CONVERTED_VENDOR_NET_VALUES') {
        return setConvertedVendorNetValues(state, action);
    }
    if (action.type === 'SET_USER_SELECTED_VENDOR') {
        return setUserSelectedVendor(state, action);
    }
    if (action.type === 'SET_NEW_DIRECT_QUOTE_SAVED') {
        return setDirectQuoteSaveSuccess(state, action);
    }
    if (action.type === 'UPDATE_TABLE_DATA') {
        return updateTableData(state, action);
    }
    if (action.type === 'RESET_QUOTE_DATA') {
        return resetQuoteData(state);
    }
    if (action.type === 'SET_VENDOR_ERROR') {
        return setVendorError(state, action);
    }
    if (action.type === 'SET_COUNTRY_ERROR') {
        return setCountryError(state, action);
    }
    if (action.type === 'SET_USER_SELECTED_TOTAL_VENDOR_NET_VALUE') {
        return setUserSelectedTotalVendorNetValue(state, action);
    }
    if (action.type === 'SET_MAX_NET_VALUE') {
        return setMaxNetValue(state, action);
    }
    if (action.type === 'SET_QUOTE_REQUEST_TYPE_OPTIONS') {
        return setQuoteRequestTypeOptions(state, action);
    }
    if (action.type === 'SET_LEAD_ORIGIN_OPTIONS') {
        return setLeadOriginOptions(state, action);
    }
    if (action.type === 'SET_LEAD_SOURCE_OPTIONS') {
        return setLeadSourceOptions(state, action);
    }
    if (action.type === 'SET_REJECTION_REASON_OPTIONS') {
        return setRejectionReasonOptions(state, action);
    }    
    if (action.type === 'SET_ENABLE_UNIFIED_CAPABILITIES') {
        return setEnableUnifiedCapabilities(state, action);
    }
    return state;
}

export default reducer;